module.exports = __webpack_public_path__ + "static/media/albania.d367773c.png";